'use client';

import { useNavigate } from 'react-router-dom';

import CartButton from '@/components/cart-button';

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
      <div className="flex items-center justify-between px-3 py-2.5 h-[50px]">
        <button className="w-[30px] h-[30px] flex items-center justify-center" onClick={() => navigate(-1)}>
          <img src="/icons/back.svg" alt="뒤로가기" width={30} height={30} />
        </button>

        {/* 타이틀 */}
        <h1 className="text-lg font-semibold text-gray-900">공세계 예약 주문</h1>

        {/* 장바구니 아이콘 */}
        <CartButton />
      </div>
    </header>
  );
}
